var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJozunaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#424242"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6414 38.9967C14.6414 34.3585 16.4474 30.0016 19.7237 26.7204C23.0049 23.4391 27.3618 21.6382 32 21.6382C36.6381 21.6382 40.995 23.4441 44.2763 26.7204C47.5575 30.0016 49.3585 34.3585 49.3585 38.9967C49.3585 41.2418 48.9342 43.4227 48.125 45.4506C51.1694 41.8092 53 37.1168 53 32C53 20.3997 43.6003 11 32 11C20.3997 11 11 20.3997 11 32C11 37.1168 12.8306 41.8092 15.875 45.4506C15.0658 43.4276 14.6414 41.2467 14.6414 38.9967Z",
    fill: "url(#paint0_linear_245_8090)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53.0001C35.8669 53.0001 39.0016 49.8654 39.0016 45.9985C39.0016 42.1316 35.8669 38.9968 32 38.9968C28.1331 38.9968 24.9984 42.1316 24.9984 45.9985C24.9984 49.8654 28.1331 53.0001 32 53.0001Z",
    fill: "url(#paint1_linear_245_8090)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6431 45.9983C21.6431 40.2845 26.2911 35.6365 32.0049 35.6365C37.7187 35.6365 42.3667 40.2845 42.3667 45.9983C42.3667 46.9803 42.2286 47.9326 41.9671 48.8355C44.4638 46.3092 46.0032 42.8355 46.0032 39.0016C46.0032 31.2697 39.7368 25.0033 32.0049 25.0033C24.273 25.0033 18.0066 31.2697 18.0066 39.0016C18.0066 42.8355 19.546 46.3092 22.0427 48.8355C21.7862 47.9326 21.6431 46.9852 21.6431 45.9983Z",
    fill: "url(#paint2_linear_245_8090)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53.0001C35.8669 53.0001 39.0016 49.8654 39.0016 45.9985C39.0016 42.1316 35.8669 38.9968 32 38.9968C28.1331 38.9968 24.9984 42.1316 24.9984 45.9985C24.9984 49.8654 28.1331 53.0001 32 53.0001Z",
    fill: "url(#paint3_linear_245_8090)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_8090",
    x1: 11,
    y1: 28.2204,
    x2: 53,
    y2: 28.2204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_8090",
    x1: 25.0033,
    y1: 45.9985,
    x2: 39.0016,
    y2: 45.9985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_8090",
    x1: 18.0016,
    y1: 36.9145,
    x2: 46.0032,
    y2: 36.9145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_245_8090",
    x1: 25.0033,
    y1: 45.9985,
    x2: 39.0016,
    y2: 45.9985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJozunaLogo);
export default __webpack_public_path__ + "static/media/jozunaLogo.5dca389ac1468daa0ca428034d9f8d5c.svg";
export { ForwardRef as ReactComponent };